import { Component, input, output } from '@angular/core';
import { SubscriptionPlan } from '@shared/interfacres/user';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-plan-select',
  imports: [
    MatButton
  ],
  templateUrl: './plan-select.html',
  styleUrl: './plan-select.scss'
})
export class PlanSelect  {
  plans = input<SubscriptionPlan[]>([]);
  activePlanId = input<string>('');
  selected = output<string>();

  select(planId: string) {
    this.selected.emit(planId);
  }
}
